/**
 * Cookie Utility for Auth Session Persistence
 * Using react-cookie package
 */

import { Cookies } from "react-cookie";
import type { SteContext } from "../api";

const AUTH_COOKIE_NAME = "callee_auth";
const COOKIE_MAX_AGE = 60 * 60 * 24; // 1 day in seconds

interface AuthCookieData {
  token: string;
  steContext: SteContext;
}

// Create a cookies instance for use outside React components
const cookies = new Cookies();

/**
 * Set the auth cookie with credentials
 */
export function setAuthCookie(data: AuthCookieData): void {
  cookies.set(AUTH_COOKIE_NAME, data, {
    path: "/",
    maxAge: COOKIE_MAX_AGE,
    sameSite: "strict",
    secure: true,
  });
}

/**
 * Get the auth cookie data
 */
export function getAuthCookie(): AuthCookieData | null {
  const data = cookies.get(AUTH_COOKIE_NAME);
  return data || null;
}

/**
 * Clear the auth cookie
 */
export function clearAuthCookie(): void {
  cookies.remove(AUTH_COOKIE_NAME, { path: "/" });
}
